// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected-tags span[data-v-be6010d0] {\n  line-height: 28px;\n}", ""]);
// Exports
module.exports = exports;
